import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import { Button, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import type { ConditionField } from "../../../../../../../../api/types/svTypes.ts";
import MetaIcon from "../../../common/MetaIcon.tsx";
import { formatCaption } from "../conditions/conditionsHelper.tsx";

interface Props {
  linkableConditions: ConditionField[];
  disableEqualitySelection?: boolean;
  setLinkedCondition: (condition: ConditionField) => void;
}

const LinkConditions = ({ linkableConditions, disableEqualitySelection, setLinkedCondition }: Props) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
  const [menuWidth, setMenuWidth] = useState(0);

  return (
    <>
      <Button
        color="inherit"
        fullWidth
        disableRipple
        sx={{
          justifyContent: "flex-start",
          px: 2,
          py: 0.75,
          fontWeight: "fontWeightRegular",
        }}
        startIcon={<LinkRoundedIcon color="secondary" />}
        onClick={(e) => {
          setMenuAnchorEl(e.currentTarget);
          setMenuWidth(e.currentTarget.offsetWidth);
        }}
        disabled={linkableConditions.length === 0}
      >
        Link Condition
      </Button>
      {menuAnchorEl && (
        <Menu
          open
          anchorEl={menuAnchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          slotProps={{
            paper: {
              sx: {
                boxShadow: "0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)",
                width: "100%",
                maxWidth: `${menuWidth}px`,
                maxHeight: "350px",
              },
            },
          }}
          onClose={() => setMenuAnchorEl(null)}
        >
          <Typography variant="subtitle2" color={"secondary"} sx={{ px: 2, py: 0.625 }}>
            Link Condition
          </Typography>
          {linkableConditions.map((condition) => (
            <MenuItem
              key={condition.config.guid}
              onClick={() => {
                setLinkedCondition({ ...structuredClone(condition) });
                setMenuAnchorEl(null);
              }}
              sx={{ pl: 3, py: 1 }}
            >
              <Grid
                sx={[
                  { display: "flex", flex: 1, alignItems: "center", gap: 1.5 },
                  (t) => ({ width: "100%", "& .MuiSvgIcon-root": { color: t.palette.secondary.light } }),
                ]}
              >
                <MetaIcon icon={condition.meta.icon} />
                {formatCaption(condition, undefined, disableEqualitySelection, "body1")}
              </Grid>
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};
export default LinkConditions;
